// NotificationsPage.tsx - Notifications management page
import { Container, Title, Text, Stack, Tabs, Paper, Group, Button, Badge } from '@mantine/core';
import { IconMail, IconMessage, IconBell, IconHistory } from '@tabler/icons-react';
import { NotificationCenter } from '@/components/notifications/NotificationCenter';
import { useState } from 'react';

export function NotificationsPage() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="lg">
        <div>
          <Title order={1}>Notifications</Title>
          <Text c="dimmed" mt="xs">
            Manage email, SMS, and push notifications
          </Text>
        </div>
        <NotificationCenter />
      </Stack>
    </Container>
  );
}
